import React from "react";
import PropTypes from "prop-types";
import Textarea from "react-textarea-autosize";

const propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
};

const defaultProps = {
  id: null,
  name: null,
  style: {},
};

function TextareaInput({ style, ...props }) {
  return (
    <Textarea
      minRows="2"
      {...props}
      className="ant-input ant-input-outlined"
      style={{ width: "100%", borderRadius: "5px", ...style }}
    />
  );
}

TextareaInput.propTypes = propTypes;
TextareaInput.defaultProps = defaultProps;

export default TextareaInput;
